import { memo, useState } from 'react'
import type { Dispatch, SetStateAction } from 'react'
import { Object3D } from 'three'
import Effects from './Effects'
import Interactables from './Interactables'
import type { ActiveAnimations } from './AnimationMixer'

interface HoverLayerProps {
  interactables: Object3D[]
  activeCam: number
  isCurrentlyPlayingAnimations: boolean
  onOpenModal: (url: string) => void
  setActiveAnimations: Dispatch<SetStateAction<ActiveAnimations>>
}

// Owns the hovered-mesh state so that pointer hovers only re-render the outline
// pass (Effects) and not the rest of the canvas (Camera, World, mixer, markers).
// Interactables is the sole producer of the hover, Effects the sole consumer.
function HoverLayer({ interactables, activeCam, isCurrentlyPlayingAnimations, onOpenModal, setActiveAnimations }: HoverLayerProps) {
  const [hoveredMesh, setHoveredMesh] = useState<string | null>(null)

  return (
    <>
      <Effects
        interactables={interactables}
        activeCam={activeCam}
        isCurrentlyPlayingAnimations={isCurrentlyPlayingAnimations}
        hoveredMesh={hoveredMesh}
      />
      <Interactables
        interactables={interactables}
        activeCam={activeCam}
        onHoverChange={setHoveredMesh}
        onOpenModal={onOpenModal}
        setActiveAnimations={setActiveAnimations}
        isCurrentlyPlayingAnimations={isCurrentlyPlayingAnimations}
      />
    </>
  )
}

export default memo(HoverLayer)
